import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { IoSearch } from "react-icons/io5";

import PexelsVideos from "./pexels";

const CanvasGenerator = () => {
  const [searchText, setSearchText] = useState("");

  return (
    <Container id="generate">
      <Typography align="center" size="3.6rem" weight="semibold">
        Spotify Canvas Generator
      </Typography>
      <Subheader>
        <Typography
          mt="2"
          size="2xl"
          color={Colors.grey600}
          weight="medium"
          align="center"
        >
          Get Free Custom Spotify Canvas Animations for Your Tracks. by{" "}
          <span color={Colors.white100}>Pexels</span>
        </Typography>
      </Subheader>
      <SearchContainer>
        <SearchInput
          placeholder="Search videos from pexels"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
          >
            <path
              d="M8.16732 13.9997C11.6651 13.9997 14.5007 11.1641 14.5007 7.66634C14.5007 4.16854 11.6651 1.33301 8.16732 1.33301C4.66951 1.33301 1.83398 4.16854 1.83398 7.66634C1.83398 11.1641 4.66951 13.9997 8.16732 13.9997Z"
              stroke="#909090"
            />
            <path
              d="M12.834 12.333L15.1673 14.6663"
              stroke="#909090"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </SearchContainer>
      <PexelsVideos searchText={searchText} />
    </Container>
  );
};

export default CanvasGenerator;

const Container = styled.div`
  position: relative;
`;

const Subheader = styled.div`
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const SearchContainer = styled.div`
  margin-top: 2.4rem;
  margin-left: auto;
  margin-right: auto;
  width: 36rem;
  border: 1px solid ${Colors.grey600};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem;
  background-color: ${Colors.grey900};
`;

const SearchInput = styled.input`
  width: 80%;
  outline: none;
  border: none;
  color: white;
  cursor: text;
  ::placeholder {
    color: ${Colors.grey500};
  }
`;
